import ZwxSm from './sm'

/**
 * 添加LocalStorage
 * */
let addLocalStorage = (key, value) => {
  if (value === null || value === undefined) return delLocalStorage(key)
  value = String(value)
  localStorage.setItem(key, ZwxSm.sm4JsEncrypt(value))
}

/**
 * 获取LocalStorage
 * */
let getLocalStorage = key => {
  return ZwxSm.sm4JsDecrypt(localStorage.getItem(key))
}

/**
 * 获取LocalStorage，不存在给默认值
 * */
let getLocalStorageDefault = (key, defaultValue) => {
  const value = getLocalStorage(key)
  if (value === undefined || value === null) return defaultValue
  return value
}

/**
 * 删除LocalStorage
 * */
let delLocalStorage = key => {
  localStorage.removeItem(key)
}

/**
 * 获取LocalStorage中全部key
 */
let getLocalStorageKeys = () => {
  const keys = []
  for (let i = 0, length = localStorage.length; i < length; i++) {
    keys.push(localStorage.key(i))
  }
  return keys
}

export default { addLocalStorage, getLocalStorage, getLocalStorageDefault, delLocalStorage, getLocalStorageKeys }
